import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { GALLERY_SCROLL_THRESHOLD } from '../constants/common';

function ScrollableContent({ children, onLoadMore }) {
  const scrollContainerRef = useRef(null);
  const sentinelRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    if (!sentinelRef.current || !scrollContainerRef.current) return;

    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && entries[0].intersectionRatio > 0) {
          const hasScroll =
            scrollContainerRef.current.scrollHeight > scrollContainerRef.current.clientHeight;

          if (!hasScroll) {
            return;
          }

          onLoadMore();
        }
      },
      {
        root: scrollContainerRef.current,
        rootMargin: `${GALLERY_SCROLL_THRESHOLD}px`,
      }
    );

    observerRef.current.observe(sentinelRef.current);

    // eslint-disable-next-line consistent-return
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [onLoadMore]);

  return (
    <div ref={scrollContainerRef} className="ws-scrollable-content">
      {children}
      <div ref={sentinelRef} className="ws-scrollable-content__sentinel" />
    </div>
  );
}

ScrollableContent.propTypes = {
  children: PropTypes.node.isRequired,
  onLoadMore: PropTypes.func.isRequired,
};

export default ScrollableContent;
